<template>
    <div class="lottery_modal_container">
        <div class="home_btn" @click="backHome">
          <img :src=defultCloseIcon alt="" srcset="">
        </div>
        <div
            v-if="!loading"
            style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
            "
        >
            <div v-if="!showMessageModal">
                <!-- <img src="../assets/hongbao/img/modal_bgtw.png" alt="" style="width: 100%; "> -->
                <img :src="defultHongBaoBg" style="width: 100%"/>
                    <div class="envelope_cover1">
                        <!-- <img :src="require('../assets/hongbao/img/envelope01' + lang + '.png')" -->
                          <img :src="defultHongBao"
                            data-bs-target="#exampleModalToggle2"
                            @click="chooseHongbao"
                            data-bs-toggle="modal"
                            class="envelope02"
                        />
                        <!-- <img :src="require('../assets/hongbao/img/envelope02' + lang + '.png')" -->
                          <img :src="defultHongBao"
                            data-bs-target="#exampleModalToggle2"
                            @click="chooseHongbao"
                            data-bs-toggle="modal"
                            class="envelope02"
                        />
                        <!-- <img :src="require('../assets/hongbao/img/envelope03' + lang + '.png')" -->
                          <img :src=" defultHongBao"
                            data-bs-target="#exampleModalToggle2"
                            @click="chooseHongbao"
                            data-bs-toggle="modal"
                            class="envelope02"
                        />
                </div>
            </div>

            <div class="dialog" v-if="showMessageModal">
                <div class="dialog_content">
                    <!-- <div class="dialog_alert"> -->
                      <div class="dialog_alert" :style="{ backgroundImage: defultWinningDialog }">
                        <div class="text">
                            {{ msg }}<br />
                            {{ msg2 }}<br />
                        </div>

                        <div class="close_btn">
                            <span style="font-size: 16px;color: #B28247;">{{ $t("turn.count") }}：{{memberCount}}</span><br />
                            <img @click="closeMessage"
                                :src="defultWinningDialogButton"
                                style="width: 80px"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bg from "../assets/hongbao/img/modal_bg1.png";

export default {
    props: {
      memberCount: {
        type: Number,
      },
      userData: {},
      awardsList: {
        type: Array,
        default: function () {
          return [];
        },
      },
      loading: {
        type: Boolean,
        default: true,
      },
      propsMsg: '',
      propsMsg2: '',
      templateImage: '',
      code: '',
      lang: {
        type: String,
        default: 'zh-tw'
      }
    },
    watch: {

      templateImage(newData, oldData) {
        this.templateImage = newData
        this.generateDynamicPrizes();
      },
    },
    data() {
        return {
            showMessageModal : false,
            show: false,
            msg: "",
            msg2: "",
            wingHongbaoModal: "",
            rolling: false,
            backgroundUrl: `url(${bg})`,
            defultHongBaoBg: require('../assets/hongbao/img/modal_bg' + this.lang + '.png'),
            defultHongBao: require('../assets/hongbao/img/envelope01.png'),
            defultCloseIcon: require("../assets/defult/img/closebtn.png"),
            defultWinningDialogButton: require('../assets/hongbao/img/comfirBtnGa' + this.lang + '.png'),
            defultWinningDialog: `url(${bg})`,
        };
    },
    mounted() {
    },
    computed: {},
    methods: {
        generateDynamicPrizes() {
          if (this.templateImage != '') {
            const json_image = JSON.parse(this.templateImage)
            console.log(json_image)
            for (const [key, value] of Object.entries(json_image)) {
              switch (key) {
                case "Hongbaobg":
                  this.defultHongBaoBg = value
                  break;
                case "Hongbao":
                  this.defultHongBao = value
                  break;
                case "CloseIcon":
                  this.defultCloseIcon = value
                  break;
                case "WinningDialogButton":
                  this.defultWinningDialogButton = value
                  break;
                case "WinningDialog":
                  this.defultWinningDialog =`url(${value})`
                  break;
              
                default:
                  break;
              }
            }
          }
        
        },
        chooseHongbao() {
            if (this.code != "0") {
              this.showMessageModal = true
              this.msg = this.propsMsg
              this.msg2 = this.propsMsg2
            }else{
              //如果次數為0 不得抽獎
              if (this.memberCount === 0 || this.memberCount === null) {
                  this.msg = this.$t("turn.zero");
                  this.msg2 = "";
                  // 如果尚在抽獎中不執行任何動作
              } else {
                  if (this.rolling) {
                      this.msg = this.$t("turn.drawing");
                      this.msg2 = "";
                      return;
                  }
                  this.getWinning();
              }
            }
        },
        async getWinning() {
            this.rolling = true;
            let postData = {
                Token: this.userData.token,
                PEid: this.userData.peid,
            };
            await fetch("/api/drawEvents", {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res.code == "0") {
                        this.roll(res.data);
                    } else {
                      this.showMessageModal = true;
                      this.msg = this.$t('turn.' + res.data)
                      this.msg2 = this.$t("turn.contact");
                      this.rolling = false;
                    }
                });
        },
        roll(result) {
            if (isNaN(result)) {
                let jresult = JSON.parse(result);
                let result_name = Object.keys(jresult);
                result = result_name[0];
            }
            setTimeout(() => {
                this.showMessageModal = true;
                this.msg = this.$t("turn.congratulations");
                this.msg2 = this.awardsList[result];

                this.rolling = false;
                this.$emit("rollDone", 1);
                this.button_disabled = false;
            }, 200);
        },
        backHome() {
          this.$emit('closeDialog', false)
        },
        closeMessage() {
          this.$emit('closeDialog', false)
          this.showMessageModal = false;
        },
    },
};
</script>


<style scoped>
@import "../assets/hongbao/css/style.css";
@import "../assets/hongbao/css/animate.css";
@import "../assets/hongbao/css/bootstrap.css";
</style>



// WEBPACK FOOTER //
// src/components/hongbao_modal1.vue